document.addEventListener("DOMContentLoaded", function () {

    $('.reju-shop_nav_btn').click(function(){
        $('.reju-shop_nav_btn').removeClass('active');
        $(this).addClass('active');
        var currentId = $(this).attr('data-id');
        $('.reju-shop-block').addClass('hided');
        $('.reju-shop-block[data-id="'+currentId+'"]').removeClass('hided');
    });


    $(document).on("click",".vv_ugc_block",function() {
        var currentState = $(this).find('.vv_ugc_video_control').attr('data');
        console.log(currentState, 'CURRENT STATE OF UGC');

        var clickedVideo = $(this).find('video')[0];
      
          // Pause all other videos except the clicked one
          $('.vv_ugc_block').each(function() {
              var video = $(this).find('video')[0];
              if (video && video !== clickedVideo && !video.paused) {
                  video.pause();
                  $(this).find('.bdru_Control_pause').hide();
                  $(this).find('.bdru_Control_play').show();
              }
          });
      
          // Toggle play/pause for the clicked video
          $('.vv_ugc_video_control').removeClass('notVisible'); 
          if (clickedVideo) {
              if (clickedVideo.paused) {
                  clickedVideo.play();
                  $(this).find('.bdru_Control_pause').css('display', 'flex');
                  $(this).find('.bdru_Control_play').hide();
                  $(this).find('.vv_ugc_video_control').addClass('notVisible');
              } else {
                  clickedVideo.pause();
                  $(this).find('.bdru_Control_pause').hide();
                  $(this).find('.bdru_Control_play').css('display', 'flex');
              }
          }

        if (currentState == '0'){
            $(this).find('.vv_ugc_video_control').attr('data', '1');
            $(this).find('.vv_ugc_video_control').find('.bb_btn').html('Pause');
        }
        else{
            $(this).find('.vv_ugc_video_control').attr('data', '0');
            $(this).find('.vv_ugc_video_control').find('.bb_btn').html('Play');
        }
    });


    $('.reju_faq_block').click(function(){
        $(this).find('.reju_faq-content').slideToggle();
        $(this).toggleClass('active');
    });

    $('.reju_variant-cell').click(function(){
      $('.reju_variant-cell').removeClass('active');
      $(this).addClass('active');
      setVariant();
    });

    function setVariant(){
      var currentActive =  $('.reju_variant-cell.active');
      var currentPrice = currentActive.attr('data-price');
      $('.col-pp_atc_price').html(currentPrice);
    }

    function update_cart_content() {
      $.get(window.location.pathname, function (response) {
        const updatedCartDrawer = $(response).find(".cart_main_Drawer");
        $(".cart_main_Drawer").html(updatedCartDrawer.html());
    
        // const updatedCartHeader = $(response).find('.drawer__heading');
        // $('.drawer__heading').html(updatedCartHeader.html());
      });
    }

    function cart_open() {
      setTimeout(function () {
        $(".drawer.cart-drawer--desktop-width-normal").removeClass("is-empty");
      }, 500);
      $(".drawer.cart-drawer--desktop-width-normal").addClass("active");
    }

    $('.ac_cart_atc_btn').click(function(evt){
      evt.preventDefault();
      var currentId = $(this).attr('data-id');
      var currentQty = 1;
  
      var data = {
        id: currentId,
        quantity: currentQty,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          
        },
      });
    });

    $('.col_pp_atc-btn').click(function(){
      var currentId = $('.reju_variant-cell.active').attr('data-id');
      var currentQty = 1;
  
      var data = {
        id: currentId,
        quantity: currentQty,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          setTimeout(function(){
            update_cart_content();
            cart_open();
          },1500);
         
        },
      });
    });


  $(document).on("click",".reju_flex-atc-btn",function(evt) {
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".reju-product-container").offset().top
    }, 500);
  });

    document.querySelectorAll('.swiper.reju-shop_collection').forEach(function (el) {
      const id = el.getAttribute('id').replace('swiper-', '');

      new Swiper(`#swiper-${id}`, {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: {
          nextEl: `.swiper-button-next-${id}`,
          prevEl: `.swiper-button-prev-${id}`,
        },
        pagination: {
          el: `.swiper-pagination-${id}`,
          clickable: true,
        },
        breakpoints: {
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1280: { slidesPerView: 4 },
        }
      });
    });


    const swiper = new Swiper('.reju_trust-carousel', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.reju_trustreviews_grid .swiper-button-next',
          prevEl: '.reju_trustreviews_grid .swiper-button-prev',
        },
        pagination: {
          el: '.reju_trustreviews_grid .swiper-pagination',
          clickable: true,
        },
        // Optional responsive breakpoints
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }
      });


      new Swiper('.vv_ugc_carousel', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        loop: false,
        navigation: {
          nextEl: '.reju_ugc-container .swiper-button-next',
          prevEl: '.reju_ugc-container .swiper-button-prev',
        },
        pagination: {
          el: '.reju_ugc-container .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }
      });


    // Thumbnail Swiper
    var swiperThumbs = new Swiper(".mySwiperThumbs", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
    });
    
    // Main Swiper with thumbnail control
    var swiperMain = new Swiper(".mySwiper2", {
      spaceBetween: 10,
      effect: 'fade',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });


    function getBusinessDayFromToday(offsetDays) {
        let date = new Date();
        let addedDays = 0;

        while (addedDays < offsetDays) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
                addedDays++;
            }
        }

        return date;
    }

    function formatDate(date) {
        const options = { weekday: 'long', day: 'numeric', month: 'long' };
        return date.toLocaleDateString(undefined, options);
    }

    const targetDate = getBusinessDayFromToday(3);
    const formattedDate = formatDate(targetDate);
    $(".col_pp_delivery__Date").text(formattedDate);


  });
  
